const apiService = {
  post: (url, data) => {
    const promise = new Promise((resolve, reject) => {
      abp.ajax({
        url: url,
        type: 'POST',
        data: JSON.stringify(data)
      }).done(result => {
        resolve(result);
      }).fail(err => {
        console.error("Communication failed.", err);
        reject("Communication failed");
      });
    });

    return promise;
  },
}

export default apiService;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/services/api-service.js